<template>
	<b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <carrier-classification-create-or-update v-model="carrierClassification" :errors="errors"></carrier-classification-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="carrier-classification"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import CarrierClassificationCreateOrUpdate from './components/CarrierClassificationCreateOrUpdate.vue'
import CarrierClassificationApi from '@/api/operational-parameters'

export default {
	components:{
        BCard,
        CarrierClassificationCreateOrUpdate,
	},
	data(){
		return{
			editing:false,
            errors:{},
            loading:false,
            carrierClassification:{
                Id:0,
                Name:null,
                ParentCarrierClassificationId:null,
                ParentCarrierClassificationName:null
            },
            fields:[
                { name:"Nakliyeci Sınıfı Ana Grubu",key:"Name", thClass:"w-50",sortable:true},
                { name:"Nakliyeci Sınıfı",key:"ParentCarrierClassificationName", thClass:"w-50",sortable:true,sortKey:'ParentCarrierClassification.Name'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
		}
	},
	methods:{
		clearForm(){
            this.editing = false
            this.carrierClassification.Id = 0
            this.carrierClassification.Name = null
            this.carrierClassification.ParentCarrierClassificationId = null
            this.carrierClassification.ParentCarrierClassificationName = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.carrierClassification.Id = item.Id
            this.carrierClassification.Name = item.Name
            this.carrierClassification.ParentCarrierClassificationId = item.ParentCarrierClassificationId
            this.carrierClassification.ParentCarrierClassificationName =item.ParentCarrierClassificationName
            this.$showModal('create-or-update')
        },
        provider(data){
            return CarrierClassificationApi.CarrierClassification.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            CarrierClassificationApi.CarrierClassification.CreateOrUpdate(this.editing,this.carrierClassification)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} taşıyıcı sınıfını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    CarrierClassificationApi.CarrierClassification.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	}
}
</script>

<style>

</style>